import React from 'react';

import { useSelfSchedulingContext } from 'lib/context/SelfSchedulingContext/SelfSchedulingContext';

import Modal from 'components/shared/Modal/Modal';
import Button from 'components/shared/Button/Button';

const ResumeDraftDialog = () => {
  const { hasDraft, resumeFromDraft, startOverDraft } = useSelfSchedulingContext();

  return (
    <Modal
      isOpen={hasDraft}
      disableHeader
      isFooter={false}
      isCentered
      shouldCloseOnOverlayClick={false}
      overlayClassName="z-[300]">
      <div className="flex flex-col items-center gap-4 px-6 py-6 text-center">
        <p className="text-lg font-600 text-neutral-900">Welcome back</p>
        <p className="text-sm text-neutral-700">
          We saved your unfinished scheduling from earlier. Would you like to pick up where you left
          off, or start over?
        </p>
        <div className="mt-2 flex w-full justify-center gap-3">
          <Button onClick={() => startOverDraft()} color="neutral" outlined text="Start over" />
          <Button onClick={() => resumeFromDraft()} text="Resume" />
        </div>
      </div>
    </Modal>
  );
};

export default ResumeDraftDialog;
